import { useEffect } from 'react';
import { Text } from '@fluentui/react-components';

export default function SettingsCustomFields() {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('setPageContext', {
      detail: { title: 'Custom fields' },
    }));
    return () => {
      window.dispatchEvent(new CustomEvent('setPageContext', { detail: null }));
    };
  }, []);

  return (
    <div style={{ padding: '1rem' }}>
      <Text>Configure custom fields here.</Text>
    </div>
  );
}
